import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * HelpTip — Contextual (?) tooltip for section headers
 * Shows explanation + use case example on hover
 */
import { useState, useRef, useEffect } from 'react';
import { HelpTooltipWrapper, HelpIcon, HelpBubble, HelpBubbleTitle, HelpBubbleText, HelpBubbleExample, } from './SharedStyles';
const HelpTip = ({ title, text, example }) => {
    const [show, setShow] = useState(false);
    const timeoutRef = useRef(null);
    const handleEnter = () => {
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        setShow(true);
    };
    const handleLeave = () => {
        timeoutRef.current = setTimeout(() => setShow(false), 150);
    };
    useEffect(() => {
        return () => {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
        };
    }, []);
    return (_jsxs(HelpTooltipWrapper, { onMouseEnter: handleEnter, onMouseLeave: handleLeave, children: [_jsx(HelpIcon, { children: "?" }), show && (_jsxs(HelpBubble, { onMouseEnter: handleEnter, onMouseLeave: handleLeave, children: [title && _jsx(HelpBubbleTitle, { children: title }), _jsx(HelpBubbleText, { children: text }), example && (_jsxs(HelpBubbleExample, { children: [_jsx("strong", { children: "Example: " }), example] }))] }))] }));
};
export default HelpTip;
